module.exports = __webpack_public_path__ + "media/images/teacher/points-earned-c3c15a15e1f3cfc82271cbc7292fee55.png";